import { EventSubPageTitle } from '../breadcrumbs/EventSubPageTitle';

export const EventEditPageNav = (): React.ReactElement<any, any> | null => {
    return <EventSubPageTitle>Edit</EventSubPageTitle>;
};
